export default __webpack_public_path__ + "static/media/Patient2.9c996a15.png";